import React, { useEffect, useState } from 'react';
import { setListPageSize } from 'app/Pages/common/List';
import { makeRequestQuery, preflightAPICall, processAPIError } from 'utils';
import axios from 'axios';
import { TFetchStatus, TListData } from 'models';
import { API_USER_LIST_URL } from 'config/api';
import { TUser } from 'app/Pages//common';
import ListComponent from './List';

interface IProps {
  brokerId: string,
}

export type TTableData = TListData & { results?: TUser[] };

const Agents = ({ brokerId }: IProps) => {
  const [fetchStatus, updateFetchStatus] = useState<TFetchStatus>('loading');
  const [itemList, updateItemList] = useState<TTableData>({});
  const [noResultsText, updateNoResultsText] = useState('');
  const [searchQuery, updateSearchQuery] = useState('');

  useEffect(() => {
    if (brokerId) {
      getList({});
    }
    // eslint-disable-next-line
  }, [searchQuery, brokerId]);

  const getList = ({ page }: { page?: number }) => {
    updateFetchStatus('loading');
    let query: Record<string, string | number> = {};

    query.page_size = setListPageSize();

    if (page) {
      query.page = page;
    }

    if (searchQuery) {
      query.name = encodeURIComponent(searchQuery);
    }

    query.broker_id = brokerId;

    const queryString = makeRequestQuery(query);

    preflightAPICall(() => {
      axios.get(`${API_USER_LIST_URL}${queryString}`).then(response => {
        const data = response.data;
        updateItemList(data);
        updateFetchStatus('success');

      }).catch(error => {
        updateFetchStatus('failed');
        updateItemList({
          results: [],
        });

        updateNoResultsText(() => processAPIError(error) as string);

      });
    });
  };

  const handleListChangePage = (page: number) => {
    getList({ page });
  };

  return (
    <ListComponent
      handleSearchChange={updateSearchQuery}
      noResultsText={noResultsText}
      fetchStatus={fetchStatus}
      userList={itemList}
      handleListChangePage={handleListChangePage}
    />
  );

};


export default Agents;
